module.exports = __webpack_public_path__ + "img/Rhodesian.e2d0813a.svg";